/** Bileşik Simpson. n çift olmalı (tek verilirse +1). */
export function simpson(f: (z: number) => number, a: number, b: number, n = 200): number {
  if (b <= a) return 0;
  if (n % 2 === 1) n += 1;
  const h = (b - a) / n;
  let s = f(a) + f(b);
  for (let i = 1; i < n; i++) s += f(a + i * h) * (i % 2 === 0 ? 2 : 4);
  return (s * h) / 3;
}

/** ∫f ve ∫z·f / ∫f (ağırlık merkezi koordinatı). F = 0 ise zBar orta nokta. */
export function integrateWithCentroid(f: (z: number) => number, a: number, b: number, n = 200): { F: number; zBar: number } {
  const F = simpson(f, a, b, n);
  if (Math.abs(F) < 1e-12) return { F: 0, zBar: (a + b) / 2 };
  const M = simpson((z) => z * f(z), a, b, n);
  return { F, zBar: M / F };
}
